import { FC } from 'react';

import TrustpilotRating from '@components/quiz/shared/TrustpilotRating';
import AsSeenOnStrip from '@components/quiz/shared/AsSeenOnStrip';
import type { SanityTrustItem } from '@lib/sanity/types';

// Brand-level stat, not per-page copy; updated with the marketing site.
const MANAGER_COUNT = '700,000+';

type ProofStripProps = {
  /** Trust config from the page's paywall block, so the early proof strip and
   *  the paywall's own strip can never disagree on the same page. */
  trustpilotTemplateId?: string;
  trustpilotHeight?: string;
  trustpilotWidth?: string;
  asSeenOnLabel?: string;
  asSeenOnItems?: SanityTrustItem[];
  asSeenOnMonochrome?: boolean;
  asSeenOnLogoHeight?: number;
};

/**
 * Early trust strip under the hero. Renders the live Trustpilot widget and the
 * Sanity-driven "as seen on" outlets (the same sources the paywall block uses
 * further down), so the score and outlets stay in step with reality instead of
 * being frozen in code.
 */
const ProofStrip: FC<ProofStripProps> = ({
  trustpilotTemplateId,
  trustpilotHeight,
  trustpilotWidth,
  asSeenOnLabel,
  asSeenOnItems,
  asSeenOnMonochrome,
  asSeenOnLogoHeight
}) => (
  <section className="border-b border-landing-hairline bg-white px-6 py-4">
    <div className="mx-auto w-full max-w-md md:max-w-2xl">
      <p className="mb-2 text-center text-sm font-semibold text-landing-slate">
        <span className="text-landing-ink">{MANAGER_COUNT}</span> managers
      </p>
      <TrustpilotRating
        templateId={trustpilotTemplateId}
        height={trustpilotHeight}
        width={trustpilotWidth}
      />

      {asSeenOnItems && asSeenOnItems.length > 0 && (
        <div className="mt-3 border-t border-dashed border-landing-hairline pt-3">
          <AsSeenOnStrip
            items={asSeenOnItems}
            label={asSeenOnLabel}
            monochrome={asSeenOnMonochrome}
            logoHeight={asSeenOnLogoHeight}
          />
        </div>
      )}
    </div>
  </section>
);

export default ProofStrip;
